import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce'
import { CONOFFICER_API, SUPRIVISOR_API, DAPPROVER_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { getCountry, getcountryname, getState } from '../reduxactions/suprivisoractions/SuprivisorProfileActions';
import { UploadImagepic } from '../reduxactions/ConsultancyActions/ProfileActions';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { fetchDoctorDatasss } from '../reduxactions/ConsultancyActions/ProfileActions';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import eventBus from '../doctorapprover/eventBus';

export const CProfile = () => {
  const uid = window.sessionStorage.getItem('uid');

  const [globalFilter, setGlobalFilter] = useState('');

  const [activeIndex, setActiveIndex] = useState(0);
  const options = ['Personal Info', 'Hospital Info'];
  const [value, setValue] = useState(options[0]);



  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.cprofile.data);
  const toast = useRef(data);
  //console.log(data,"data get")
  const [checked, setChecked] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [photo, setPhoto] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [pincode, setPincode] = useState('');

  useEffect(() => {
    const profilephoto = data[0]?.photo;
    window.sessionStorage.setItem('photo', profilephoto);
    handlePhotoUpdate(profilephoto);
  }, [data]);

  const handlePhotoUpdate = (newPhoto: any) => {
    setPhoto(newPhoto);
    eventBus.emit('photoUpdated', newPhoto);
  };

  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchDoctorDatasss(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchDataAsync();
  }, [dispatch]);
  const [profiledata, setProfiledata] = useState<[]>([]);
  //To get data
  const fetchDataAsync1 = async () => {
    try {
      const payload = { uid: uid };
      const apiname = CONOFFICER_API.cprofile_API;
      const response = await LoginService.getData(apiname, payload);
      setProfiledata(response)
      setPhoto(response[0].photo)
      setFirstName(response[0].firstName);
      setLastname(response[0].lastName);
      setEmail(response[0].email);
      setPhone(response[0].phone);
      setCountry(response[0].country);
      setState(response[0].state);
      setCity(response[0].city);
      setAddress(response[0].address);
      setPincode(response[0].pin);

      const country = response[0].country;
      if (country && country.length > 0) {
        fetchstate(country);
        getcountryvalue(country);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const countrydata = useSelector((state: RootState) => state.sprofile.country);
  const statedata = useSelector((state: RootState) => state.sprofile.state);

  const data1 = useSelector((state: RootState) => state.cprofile.data);
  const [selectedFile, setselectedFile] = useState<File | null>(null);

  const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
    const files = event.files;
    if (files.length > 0) {
      const file = files[0];
      console.log("file:", file);
      setselectedFile(file);
      console.log("called image function:", file)
      toast.current.show({ severity: 'success', summary: 'Image Uploaded successfully', life: 3000 });
      try {
        await dispatch(UploadImagepic(file, uid) as any);
        fetchDataAsync();
        fetchDataAsync1();
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }

  };
  const fetchcountry = async () => {
    try {
      await dispatch(getCountry() as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffectOnce(() => {
    fetchcountry();
    fetchDataAsync1();
  }, [dispatch]);

  const getcountryvalue = async (country: any) => {
    try {
      await dispatch(getcountryname(country) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchstate = async (country: any) => {
    try {
      await dispatch(getState(country) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };
  const getAddressData = async () => {
    try {
      const payload = { address: address, uid: uid, q: 1 };
      const apiname = SUPRIVISOR_API.verifyadd;
      const data = await LoginService.getData(apiname, payload);
      toast.current.show({ severity: 'success', summary: 'Address Verified successfully', life: 3000 });
      if (data) {
        setAddress(data);
        //toast.current.show({ severity: 'success', summary: 'Verified Successfully', details: verify, life: 3000 });
      } else {
        setAddress('')
        console.warn('Invalid or empty response:', data);
      }
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  const updateProfilePersonal = async () => {
    try {
      const payload = { phone: phone, address: address, city: city, country: country, state: state, name: firstName, lname: lastname, email: email, pin: pincode, uid: uid };
      const apiname = DAPPROVER_API.daupdateprofile_API;
      const data = await LoginService.getData(apiname, payload);
      //fetchDataAsync();
      toast.current.show({ severity: 'success', summary: 'Updated successfully', life: 3000 });

    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/consofficerprofile.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="col-16" style={{ textAlign: "right" }}>
            <a
              title="help"
              onClick={(e) => openWindow(e, IUrl)}
              style={{

                color: "blue",
                fontSize: 15, cursor: "pointer"
              }}
            >Help for this Page &nbsp;
              <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

            </a>
          </div>
          <div className="content-wrapper">
            <section className="content">
              <div className="grid">

                <div className="col-3">
                  <Panel header="" style={{ width: '400px', marginTop: '40px' }}>
                    <div
                      className="widget-user-header bg-info"
                      style={{
                        borderRadius: '10px 10px 0 0',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <br></br>
                      <br></br>
                      <br></br>
                      <img
                        src={photo}
                        alt="User Avatar"
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%',
                          position: 'absolute',
                          bottom: '-20px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          border: '4px solid white',
                        }}
                      />
                    </div>
                    <h3
                      className="widget-user-username"
                      style={{
                        color: 'black',
                        fontSize: '25px',
                        fontWeight: '300',
                        marginBottom: '20px',
                        marginTop: '30px'
                      }}
                    >
                      {firstName}
                    </h3>
                    <h2
                      className="widget-user-username"
                      style={{
                        color: '#6c757d',
                        fontSize: '25px',
                        fontWeight: '300',
                        marginBottom: '20px',
                      }}
                    >
                      Consultancy Officer
                    </h2>
                    <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                    {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}

                  </Panel>


                </div>
                {data.map((response: any) =>
                  <div style={{ marginTop: '0px', marginRight: '0px' }}>
                    <div className='col-4'></div>
                    <div className='col-2'></div>
                    <div>
                      <Panel header="Profile" className="profile-header" style={{ width: '700px', marginLeft: '130px', marginTop: '-30px' }}>
                        <div className="grid">
                          <div className="col-12">
                            <div className="flex align-items-center mb-3">
                              <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>FirstName:</label>
                              <InputText id="nameoforg" type="text" placeholder="Enter Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                            </div>
                            <div className="flex align-items-center mb-3">
                              <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>LastName:</label>
                              <InputText id="nameoforg" type="text" placeholder="Enter Name" value={lastname} onChange={(e) => setLastname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                            </div>

                            <div className="flex align-items-center mb-3">
                              <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                              <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                            </div>

                            <div className="flex align-items-center mb-3">
                              <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                              <InputText id="phone" type="number" placeholder="Enter Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />

                            </div>
                            <div className="flex align-items-center mb-3">
                              <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>
                              <Dropdown id="country" value={country} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px' }} />
                            </div>

                            <div className="flex align-items-center mb-3">
                              <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                              <Dropdown id="country" value={state} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px' }} />
                            </div>

                            <div className="flex align-items-center mb-3">
                              <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                              <InputText id="phone" type="text" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                            </div>

                            <div className="flex align-items-center mb-3">
                              <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                              <InputText id="phone" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                              {/* <i className="pi pi-map-marker" style={{ fontSize: '2em', cursor: 'pointer' }} onClick={getAddressData}></i> */}
                            </div>
                            <div className="flex align-items-center mb-3">
                              <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Pincode:</label>
                              <InputText id="phone" type="text" placeholder="Enter Pincode" value={pincode} onChange={(e) => setPincode(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />

                            </div>
                            <div className="p-field-checkbox">
                              <input type="checkbox" id="remember" checked={isChecked} onChange={handleCheckboxChange} style={{ marginRight: '10px' }} />
                              <label htmlFor="terms" className="p-checkbox-label">
                                I agree to the Terms & Conditions
                              </label>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div className="flex justify-content-end">

                              <Button label="Update" className="p-button-primary" onClick={updateProfilePersonal} />
                            </div>
                          </div>

                        </div>
                      </Panel>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
      <Toast ref={toast} >
        <Message severity="success" content={data} />
      </Toast>
    </div>

  )
}
